module.exports = __webpack_public_path__ + "static/media/15_fandbasia.f9ba0f2a.svg";